module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('row', [_c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('va-small-box', {
    attrs: {
      "color": "aqua",
      "icon": "ion-bag",
      "title": "150",
      "description": "New Order",
      "moreText": "More info"
    },
    on: {
      "more-click": _vm.clickToSmallBox
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('va-small-box', {
    attrs: {
      "color": "green",
      "icon": "ion-stats-bars",
      "title": "53%",
      "description": "Bounce Rate",
      "moreText": "More info"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('va-small-box', {
    attrs: {
      "color": "yellow",
      "icon": "ion-person-add",
      "title": "44",
      "description": "User Registrations",
      "moreText": "More info"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('va-small-box', {
    attrs: {
      "color": "red",
      "icon": "ion-pie-graph",
      "title": "65",
      "description": "Unique Visitors",
      "moreText": "More info"
    }
  })], 1)]), _vm._v(" "), _c('row', [_c('section', {
    staticClass: "col-lg-7 connectedSortable ui-sortable"
  }, [_c('va-chat-box'), _vm._v(" "), _c('va-todo-list'), _vm._v(" "), _c('va-quick-mail')], 1), _vm._v(" "), _c('section', {
    staticClass: "col-lg-5 connectedSortable ui-sortable"
  }, [_c('va-calendar')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cdf87b5c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard.vue
// module id = 746
// module chunks = 1